import React, { Component } from 'react';
import $ from 'jquery';
import './OverallScore.scss';
import * as constants from './constants';
import OverallScoreBlob from './OverallScoreBlob';
import ScoreBar from './ScoreBar';

class OverallScore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: (vendor.pageInfo.getLayout() === 'Mobile')
        };

        this.resizeHandler = this.resizeHandler.bind(this);
    }

    componentDidMount() {
        $(window).on('resize', this.resizeHandler);
    }

    resizeHandler() {
        let isMobile = (vendor.pageInfo.getLayout() === 'Mobile');

        if(isMobile !== this.state.isMobile) {
            this.setState({isMobile: isMobile});
        }
    }

    componentWillUnmount() {
        $(window).off('resize', this.resizeHandler);
    }

    render() {
        if(this.props.isOnlyBlob) {
            return (
                <OverallScoreBlob score={this.props.score} type={this.props.type} />
            );
        }

        return (
            <div className="overall-score__container">
                <div>
                    <span
                        className="hidden-lg hidden-md hidden-sm overall-score__blob__padding"
                        style={{width: `calc(${this.props.score}% - 43px)`}}
                    />
                    <span className="overall-score__blob__container">
                        <span className="overall-score__blob__name">{this.props.scoreDisplayName}</span>
                        <OverallScoreBlob score={this.props.score} type={this.props.type} />
                    </span>
                </div>
                {   this.props.type !== constants.DONT_BUY &&
                    this.props.type !== constants.IN_TEST &&
                    this.props.type !== constants.NOT_TESTED &&

                    <ScoreBar
                        minScore={this.props.minScore}
                        maxScore={this.props.maxScore}
                        score={this.props.score}
                        type={this.props.type}
                        isOneModelRated={this.props.isOneModelRated}
                        isMobile={this.state.isMobile}
                    />
                }
            </div>
        );
    }
}

export default OverallScore;



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/OverallScore/OverallScore.jsx